<template lang="pug">
.upload-recebimentos-lote-acao
    el-button.upload-recebimentos-lote-acao__button(
        type='secondary',
        @click='abrirModalRecebimentosLote'
    )
        i.mdi.mdi-upload(style='margin-right: 5px')
        | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.titulo') }}

    ModalUploadRecebimentosLote(
        :show='modalRecebimentosLoteVisible',
        :carregando='carregandoUploadRecebimentos',
        :dadosLote='dadosLoteRecebimentos',
        @close='fecharModalRecebimentosLote',
        @enviar='enviarRecebimentosLote'
    )

    ModalVinculoManualRecebimentosAr(
        :show='modalVinculoManualRecebimentosVisible',
        :recebimentos='recebimentosPendentesVinculo',
        :territorios='territoriosDisponiveisVinculo',
        :carregando='carregandoConfirmacaoVinculos',
        @close='fecharModalVinculoManualRecebimentos',
        @confirmar='confirmarVinculosRecebimentos'
    )

    ModalSucessoProcessamentoLoteAr(
        :show='modalSucessoProcessamentoLoteVisible',
        :contratos='contratosSucessoProcessamento',
        :carregando='carregandoConfirmacaoContratos',
        @close='fecharModalSucessoProcessamento',
        @confirmar='confirmarContratosProcessados'
    )

    ModalContratosEnLoteAr(
        :show='modalContratosEnLoteVisible',
        :contratos='contratosEnLote',
        :carregando='carregandoConfirmacaoEnLote',
        @close='fecharModalContratosEnLote',
        @confirmar='confirmarProcessamentoEnLote',
        @editar='editarContratoDoLote'
    )
</template>

<script>
import ModalUploadRecebimentosLote from '@/components/contratosOriginacao/ModalUploadRecebimentosLote.vue';
import ModalVinculoManualRecebimentosAr from '@/components/contratosOriginacao/ModalVinculoManualRecebimentosAr.vue';
import ModalSucessoProcessamentoLoteAr from '@/components/contratosOriginacao/ModalSucessoProcessamentoLoteAr.vue';
import ModalContratosEnLoteAr from '@/components/contratosOriginacao/ModalContratosEnLoteAr.vue';
import uploadRecebimentosLote from '@/mixins/uploadRecebimentosLote';

export default {
    name: 'UploadRecebimentosLoteAcao',
    components: {
        ModalUploadRecebimentosLote,
        ModalVinculoManualRecebimentosAr,
        ModalSucessoProcessamentoLoteAr,
        ModalContratosEnLoteAr
    },
    mixins: [uploadRecebimentosLote]
};
</script>

<style lang="scss">
.upload-recebimentos-lote-acao {
    display: inline-flex;
    height: 43px;

    &__button.el-button--secondary {
        height: 43px;
        margin-top: 0;
        background: rgba(0, 0, 0, 0.03);
        border-color: var(--primary);
        border-radius: 4px;
        color: var(--primary);

        &:hover,
        &:focus {
            background: rgba(0, 0, 0, 0.05);
            border-color: var(--primary);
            color: var(--primary);
        }
    }
}
</style>
